import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useTheme } from '@/contexts/ThemeContext';
import { syncPreferencesOnLogin } from '@/services/preferenceSync';

/**
 * Runs once per authenticated user id: fetch preferred_language / preferred_theme
 * from profiles and apply locally, or one-time write-back when DB columns are null.
 */
export function PreferenceSyncOnAuth() {
  const { user } = useAuth();
  const { applyThemeMode } = useTheme();
  const syncedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    const userId = user?.id ?? null;
    if (!userId) {
      syncedUserIdRef.current = null;
      return;
    }

    if (syncedUserIdRef.current === userId) {
      return;
    }
    syncedUserIdRef.current = userId;

    void syncPreferencesOnLogin(userId, { applyThemeMode });
  }, [user?.id, applyThemeMode]);

  return null;
}
